import { render, staticRenderFns } from "./CardRoleTabsComponent.vue?vue&type=template&id=4a3558aa&scoped=true"
import script from "./CardRoleTabsComponent.vue?vue&type=script&lang=js"
export * from "./CardRoleTabsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3558aa",
  null
  
)

export default component.exports